import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useState } from 'react';

import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { withFragments } from '@sorare/core/src/lib/gql';

import type { usePackOpeningDialog_cardPackGroup } from './__generated__/usePackOpeningDialog.graphql';

export const usePackOpeningDialog = withFragments(
  <T extends usePackOpeningDialog_cardPackGroup[]>(cardPackGroups: T) => {
    const {
      flags: { disableNativeIOSPackOpening = false },
    } = useFeatureFlags();

    const [openedCardPack, setOpenedCardPack] =
      useState<Nullable<T[number]['cardPacks'][number]>>(null);
    const { isIosApp, postMessage } = useIsMobileApp();

    const onPackSelect = (cardPackGroupId: string, cardPackSlug: string) => {
      const cardPackGroup = cardPackGroups.find(
        group => group.id === cardPackGroupId
      );
      const cardPack = cardPackGroup?.cardPacks.find(
        pack => pack.slug === cardPackSlug
      );
      if (!cardPackGroup || !cardPack) {
        return;
      }
      if (isIosApp && !disableNativeIOSPackOpening) {
        postMessage('buyCardPack', {
          packId: cardPack.slug,
        });
        return;
      }
      setOpenedCardPack(cardPack);
    };

    return {
      openedCardPack,
      onPackSelect,
      onPackOpeningDialogClose: () => {
        setOpenedCardPack(null);
      },
    };
  },
  {
    cardPackGroup: gql`
      fragment usePackOpeningDialog_cardPackGroup on CardPackGroup {
        id
        cardPacks {
          slug
        }
      }
    ` as TypedDocumentNode<usePackOpeningDialog_cardPackGroup>,
  }
);
